import type { AllRouteEndpoints } from "../routeTypes";
export const engagementInAppMessageColorProfilesUpdateTagsCacheKeys: AllRouteEndpoints[] = [
  "/engagement/in_app_message_color_profiles",
];
